import { axiosFactory, axiosPostFactory, axiosFormFactory, exportFilePost } from './axios-factory'
export default {
    //获取课表信息
    timetable: (params) => axiosFactory({
        url: 'live/timetable',
        params
        //? month = 2021 - 10
    }),
    //获取直播列表
    listLive: (params) => axiosFactory({
        url: 'live/listLive',
        params,
        //? sortType = create_time : asc & pageNum=2 & pageSize=10
    }),
    //获取直播详情
    getLive: (params) => axiosFactory({
        url: 'live/getLive',
        params,
        //? liveId = 39055672 - 2cbf - 11ec - a336 - fa163ecfd1b0
    }),
    // 首页直播课
    topLive: (params) => axiosFactory({
        url: 'live/topLive',
        params,
        //? startTime=2021-10-13&limit=4
    }),
    getLiveUrl: (params) => axiosFactory({
        url: 'live/getLiveUrl',
        params,
        //? startTime=2021-10-13&limit=4
    }),
    //课程管理列表导出
    getExportLive: (params) => exportFilePost({
        url: 'live/exportLive',
        params,
    }),
    //评论列表导出
    getExportComment: (params) => exportFilePost({
        url: 'res/exportComment',
        params,
    }),
}